import AuthLayout from '../../layouts/AuthLayout.vue'
import Forbidden from '../../views/Forbidden.vue'

export const publicRoutes = [
    {
        path: '/track/:orderNumber/:accessCode',
        name: 'order-tracking',
        component: () => import('@/views/public/OrderTracking.vue'),
        meta: {
            requiresAuth: false,
            layout: 'public'
        }
    },
    {
        path: '/auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import('../../views/Login.vue'),
                props: route => ({ redirect: route.query.redirect })
            },
            {
                path: 'reset-password',
                name: 'reset-password',
                component: () => import('../../views/ResetPassword.vue'),
                meta: { requiresAuth: false }
            }
        ]
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: Forbidden
    }
];
